/**
 * InstallationComponent created by karora on 16/02/19.
 */
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { Installation } from '../types/installation';

@Component({
  selector: 'installation',
  template: `<div>
  <ul>
    <li><label>Uploaded:</label>{{installation.uploaded}}</li>
    <li><label>Job ID:</label>{{installation.job_id}}</li>
    <li><label>Created by:</label>{{geoPal('createdby')}}</li>
    <li><label>Installed by:</label>{{geoPal('assignedto')}}</li>
    <li><label>Status:</label>{{installation.status}}</li>
    <li><label>MPRN:</label>{{installation.mprn}}</li>
    <li><label>GPRN:</label>{{installation.gprn}}</li>
    <li><label>Created:</label>{{installation.created_on | godate}}</li>
    <li><label>Assigned:</label>{{installation.assigned_date_time | godate}}</li>
    <li><label>Start Time:</label>{{installation.start_time | godate}}</li>
    <li><label>End Time:</label>{{installation.end_time | godate}}</li>
    <li><label>Last Updated:</label>{{installation.last_updated_date_time | godate}}</li>
    <li><label>Start Job:</label>{{installation.start_job | godate}}</li>
    <li><label>Date Corrected:</label>{{installation.date_corrected | godate}}</li>
  </ul>
  <ul>
    <ng-container *ngFor="let item of installation.geopal_data | keyvalue">
      <li *ngIf="isLink(item.value)"><a class="geopal" href="{{item.value}}" target="GeoPal">{{prettyName(item.key)}}</a></li>
    </ng-container>
  <li><label></label></li>
  </ul>
</div>
<pre>{{GeoPalData}}</pre>`,
  styles: [
    `ul { display: inline-block; list-style-type: none; margin: 1em;}`,
    `li { padding: 0.2em; margin: 1px; vertical-align: middle; }`,
    `label { display: inline-block; width: 7em; color: #607D8B; font-weight: bold; padding: 0 0.53em; }`,
    `span { display: inline-block; border-radius: 0; border: none; padding: 0.3em 0.6em; }`,
    `a.geopal { font-weight: bold; color: navy; text-decoration: underline; text-decoration-color: white; }`,
    `a.geopal:hover { color: #108010; text-decoration-color: #108010; }`,
  ],
  providers: [HubService],
})


export class InstallationComponent implements OnInit {
  @Input() hubID: number;
  installation = new Installation();
  GeoPalData = '';
  errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err && err.status !== 401) {
      console.log('InstallationComponent Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getInstallation(+params['hubid']))
    ).subscribe(
      (installation: Installation) => this.switchedHub(installation),
      err => InstallationComponent.handleRefreshError(err)
    );
  }

  switchedHub(installation: Installation) {
    this.hubID = Hub.SerialToHubID(installation.serial_no);
    this.installation = installation;
    this.GeoPalData = JSON.stringify(installation.geopal_data,null,2);
    console.log('Switched HUB: ' + this.hubID);
  }

  geoPal(key: string): string {
    if (this.installation && this.installation.geopal_data) {
      return this.installation.geopal_data[key];
    }
    return '';
  }

  isLink(value: any) {
    let result = (value as string).match(/^https:\/\//i);
    console.log(`${value} matches link? ${!!result}`);
    return !!result;
  }

  prettyName(value: string) {
    switch(value) {
      case 'getcustomersignature':
      case 'customersignatureconfirmingjobcompletion': return 'Customer Sign-Off on Completion';
      case 'confirmboilerworkingafterinstall': return 'Boiler operating after install';
      case 'takephotoofboilerinoperation': return 'Boiler in Operation';
      case 'takephotoofboilerserialnumber': return 'Boiler Serial Number';
      case 'takephotoofcontrollerthermostattobechanged':
      case 'takephotoofexistingtimeclockcontroller': return 'Existing Controls';
      case 'takephotoofcontrollerthermostatwiredbackplane':
      case 'takephotoofexistingwiredbackplateshowingwiringdetailstoterminals': return 'Existing Wiring';
      case 'takephotoofhubandsurroundingarea':
      case 'takephotoofhubandsurroundingareaafterfitted': return 'Hub and Surrounding Area';
      case 'takephotoofhubcontrollerbackplatefittedshowingwiring':
      case 'takephotoofhubwiredbackplateshowingwiringdetailstoterminals': return 'Hub Backplate with Wiring';
      case 'takephotoofhubcontrollerfittedandpoweredup': return 'Hub Fitted and Powered Up';
      case 'hubpaperwork':
      case 'takepictureofcustomersignedconsentform':
      case 'photoofdataagreement': return 'Data Agreement';
      case 'engineersignature': return 'Engineer Sign-Off';
      case 'takepictureofhubserialnumbersim': return 'Photo of Hub Serial No'
      case 'dropboxlinks': return 'Dropbox Links';
    }
    console.log(`Need a pretty name for '${value}`);
    return value;
  }
}

